import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Spinner } from "react-bootstrap";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./css/ShopCard.css";

const OfferShop = () => {
  const [shopData, setShopData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchShopData = async () => {
      try {
        const response = await fetch(
          "https://yaasaai.com/myphpapi/shop171.php"
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();
        console.log("Fetched Data:", data);

        if (!data || data.error) {
          setError(`Error: ${data?.error || "Invalid shop data received"}`);
          return;
        }

        setShopData(data);
      } catch (err) {
        console.error("Fetch Error:", err);
        setError("Failed to fetch shop data! Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchShopData();
  }, []);

  // Render stars based on rating
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(<FaStar key={i} className="text-warning" />);
      } else if (i - 0.5 === rating) {
        stars.push(<FaStarHalfAlt key={i} className="text-warning" />);
      } else {
        stars.push(<FaRegStar key={i} className="text-muted" />);
      }
    }
    return stars;
  };

  // Handle shop visit
  const handleVisitShop = (shopId) => {
    const userEmail = localStorage.getItem("userEmail");
    if (!userEmail) {
      alert("Please log in to view offers.");
      return;
    }

    console.log("Navigating with:", { userEmail, shopId });
    navigate("/offer_shop_profile", { state: { userEmail, shopId } });
  };

  // Loading state
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p>Loading shop data...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return <div className="text-danger text-center my-5">{error}</div>;
  }

  return (
    <Card
      className="d-flex flex-row flex-wrap flex-md-nowrap shadow-sm m-2 p-1 align-items-center bg-light"
      style={{
        borderRadius: "13px",
        width: "100%",
        minHeight: "120px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.2s ease-in-out",
      }}
    >
      {/* Image container */}
      <div
        className="overflow-hidden"
        style={{
          width: "110px",
          height: "110px",
          borderRadius: "12px",
          flexShrink: 0,
          border: "2px solid coral",
        }}
      >
        <Card.Img
          src={
            shopData?.shop_image
              ? `https://yaasaai.com/ShopImages/${shopData.shop_image}`
              : "https://yaasaai.com/ShopImages/default_image.png"
          }
          alt={shopData?.shop_name || "Shop Image"}
          className="img-fluid"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.3s ease-in-out",
            borderRadius: "10px",
          }}
        />
      </div>

      {/* Shop details */}
      <Card.Body
        className="d-flex flex-column justify-content-between px-3 py-1"
        style={{ flex: 1 }}
      >
        <div className="d-flex justify-content-between align-items-start flex-wrap">
          <div>
            <Card.Title
              className="mb-1 fw-bold text-primary"
              style={{ fontSize: "1.15rem" }}
            >
              {shopData?.shop_name || "Shop Name Not Available"}
            </Card.Title>

            <div>{renderStars(parseFloat(shopData?.shop_rating) || 0)}</div>

            {shopData?.shop_offer && (
              <div className="mt-2 px-2 py-1 rounded bg-danger text-white d-inline-block small fw-semibold shadow-sm">
                {shopData.shop_offer}% OFF
              </div>
            )}
          </div>

          <div className="text-center mt-2 mt-md-0">
            {shopData?.shop_quantity === "closed" ? (
              <Card.Text
                style={{
                  color: "red",
                  fontSize: "13px",
                  fontWeight: "bold",
                  textAlign: "right",
                }}
              >
                Shop closed
              </Card.Text>
            ) : (
              <Button
                variant="outline-success"
                size="sm"
                onClick={() => handleVisitShop(shopData?.shop_id)}
                disabled={!shopData?.shop_id}
                className="fw-semibold"
              >
                View Offers
              </Button>
            )}
            <p style={{ color: "CORAL", fontSize: "11PX" }}>
              opening and closing time is 8 AM to 11 AM
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OfferShop;
